/**
 * Late-arrival CTA visibility lock (plan Edge = Objednavky = Acceptance).
 * Parity with BE `shippingDeliveryPolicyEdges.isLateComplaintCtaVisible` (G9):
 * Show iff deadline passed + not DELIVERED/CANCELED + within window +
 * lateComplaintFiledAt null / lateComplaintEverFiled false.
 * Missing/invalid `autoDeliverEligibleAt` → CTA hidden (fail-closed).
 */

export interface ShippingLateComplaintVisibilityInput {
  readonly status: string | null | undefined;
  readonly promisedDeliveryByAt: string | null | undefined;
  readonly autoDeliverEligibleAt: string | null | undefined;
  readonly lateComplaintFiledAt: string | null | undefined;
  readonly lateComplaintEverFiled?: boolean | null;
  readonly nowMs?: number;
}

export function isShippingLateComplaintCtaVisible(
  input: ShippingLateComplaintVisibilityInput,
): boolean {
  const status = input.status ?? '';
  if (status === 'DELIVERED' || status === 'CANCELED' || status === 'CANCELLED') {
    return false;
  }
  if (input.lateComplaintEverFiled === true) {
    return false;
  }
  if (input.lateComplaintFiledAt != null && String(input.lateComplaintFiledAt).length > 0) {
    return false;
  }
  const promisedMs = parseIsoMs(input.promisedDeliveryByAt);
  if (promisedMs == null) {
    return false;
  }
  const now = input.nowMs ?? Date.now();
  if (now <= promisedMs) {
    return false;
  }
  // Fail-closed: missing/invalid autoDeliverEligibleAt → hide (parity with BE edges).
  const windowEndMs = parseIsoMs(input.autoDeliverEligibleAt);
  if (windowEndMs == null) {
    return false;
  }
  if (now > windowEndMs) {
    return false;
  }
  return true;
}

function parseIsoMs(value: string | null | undefined): number | null {
  if (value == null || String(value).trim().length === 0) {
    return null;
  }
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
}
